import React, { Component } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


import Page from '../../../components/Page';
import DataTable from '../../../components/DataTable';
import { TabHolder, Tab } from '../../../components/Tabs';

import moment from 'moment';
import BlankState from '../../../components/BlankState';

import { getClearingAgents } from '../../../utils/apiService';

import { saveClearingAgent, updateClearingAgent, listClearingAgents  } from '../../../actions/clearingagent';


 class ClearingAgents extends Component{

	constructor(props){
		super(props);

		this.state = {
            clearingagents: [],
            clearingagents_loading: true,
            first_name: "",
            last_name: "",
            email: "",
            username: "",
            phone: "",
            is_active: "",
            credit_line: "",
            commission_rate: "",
            intermediary: "",

            active_clearing_agent: {}
        };
    }
    
    componentDidMount(){
        getClearingAgents()
            .then((response) => {
                this.setState({ clearingagents: response.data, clearingagents_loading: false })
            });
    }

    editClearingAgent(clearingagent) {
        this.setState({ active_clearing_agent: clearingagent })
    }

    onChange = (e) => {
        e.preventDefault();
        const { name, value } = e.target;

        this.setState({
            [name]: value
        });
    }

    onUpdateRegion = (e) => {
        e.preventDefault()

        const { clearing_agent, active_clearing_agent } = this.state

        const updatedClearingAgent = {
            id: active_clearing_agent.id,
            name: clearing_agent.name,
            code: clearing_agent.code
        };

        console.log(updatedClearingAgent)

        this.props.updateRegion(updatedClearingAgent);
    }

    onSubmitClearingAgent = (e) => {
        e.preventDefault();

        const { 
            first_name, 
            last_name, 
            other_names, 
            username, 
            email, 
            phone, 
            credit_line, 
            commission_rate,
            intermediary
         } = this.state;

        let clearing_agent = {
            user: {
                first_name, last_name, other_names, username, email, phone
            },
            profile: { 
                credit_line, commission_rate, intermediary
            },
            type: "clearing_agent"
        };

        this.props.saveClearingAgent(clearing_agent)
    }

	render(){
       

		const menuItems = [
			{ id: "clearing-agents", name: "Clearing Agents", active: true },
			{ id: "add-agent", name: "Add Agent" }
        ]
        
        let { clearingagents, clearingagents_loading} = this.state;
        
		return(
			<Page isAdminPage={ true } pageTitle="Clearing Agents">
				<div className="clearfix">
					<TabHolder menuItems={ menuItems }>
						
						<Tab menuId={ menuItems[0].id } isActive={ true }>
                        {
                            clearingagents.length > 0 ?

                                <DataTable
                                    tableId="agents-table"
                                    columnTitles={ ["Name", "Email", "Phone Number", "Broker", "Commission Rate (%)", 
                                        "Premium Deposit", "Join Date"] }>
                                        
                                {
                                    clearingagents.map((clearagent, index) => {

                                        const { user, clearing_agency, commission_rate, credit_line, date_joined } = clearagent;
                                        
                                        return (
                                            <tr>
                                                <td>{ user.first_name }</td>
                                                <td>{ user.email }</td>
                                                <td>{ user.phone }</td>
                                                <td>{ clearing_agency }</td>
                                                <td>{ commission_rate }</td>
                                                <td>{ credit_line }</td>
                                                <td>{ moment(date_joined).format('MMM Do, YYYY')}</td>
                                            </tr>
                                        )
                                    })
                                }
                                </DataTable>
                            :
                                <BlankState 
                                    data={ clearingagents } 
                                    dataName="Clearing Agents" 
                                    isDataLoading={ clearingagents_loading } />
						      }

						</Tab>

						<Tab menuId={ menuItems[1].id }>
                        
                            <div className="col-sm-7">
                            <form   
                                    className="form-horizontal" 
                                    noValidate
                                    onSubmit={ this.onSubmitClearingAgent }>
                                <div className="form-group">
                                    <label className="control-label col-md-4">First Name:&nbsp;<span className="text-danger">*</span></label>
                                    <div className="col-md-8">
                                        <input type="text" onChange={this.onChange} className="form-control" name="first_name" required />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="control-label col-md-4">Last Name:&nbsp;<span className="text-danger">*</span></label>
                                    <div className="col-md-8">
                                        <input type="text" onChange={this.onChange} className="form-control" name="last_name" required />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="control-label col-md-4">Other Names:</label>
                                    <div className="col-md-8">
                                        <input type="text" onChange={this.onChange} className="form-control"  />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="control-label col-md-4">Username:&nbsp;<span className="text-danger">*</span></label>
                                    <div className="col-md-8">
                                        <input type="text" onChange={this.onChange} className="form-control" name="username" required />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="control-label col-md-4">Email:&nbsp;<span className="text-danger">*</span></label>
                                    <div className="col-md-8">
                                        <input type="text" onChange={this.onChange} className="form-control" name="email" required />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="control-label col-md-4">Phone Number:&nbsp;<span className="text-danger">*</span></label>
                                    <div className="col-md-8">
                                        <input type="text" onChange={this.onChange} className="form-control" name="phone" required />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="control-label col-md-4">Credit Limit:&nbsp;<span className="text-danger">*</span></label>
                                    <div className="col-md-8">
                                        <input type="text" onChange={this.onChange} className="form-control" name="credit_line" required />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="control-label col-md-4">Commission Rate (%):&nbsp;<span className="text-danger">*</span></label>
                                    <div className="col-md-8">
                                        <input onChange={this.onChange} className="form-control" name="commission_rate" required />
                                    </div>
                                </div>

                                <div className="col-md-8 col-md-offset-4">
                                    <button type="submit" className="btn btn-primary">
                                        <i className="icon ion-checkmark"></i> Create Clearing Agent
                                    </button>
                                </div>
                                </form>
                            </div>
						</Tab>
					</TabHolder>
				</div>
			</Page>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
    clearing_agent: state.clearing_agent,
    clearingagents: state.clearingagents
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ listClearingAgents, updateClearingAgent, saveClearingAgent }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ClearingAgents);


// WEBPACK FOOTER //
// ./src/pages/dashboard/agents/ClearingAgents.jsx